import { createPublicEnv } from '@portal/public-env'

export const { getPublicEnv, PublicEnv } = createPublicEnv(
    {
        NEXT_PUBLIC_AUTO_TRANSLATION_ENABLE: process.env.TRANSLATION_ENABLE,
        NEXT_PUBLIC_LANG: process.env.CONTENT_LANG,
        NEXT_PUBLIC_NAVBAR_ABOUT_PAGE_LINK_ENABLE: process.env.NEXT_PUBLIC_NAVBAR_ABOUT_PAGE_LINK_ENABLE,
        NEXT_PUBLIC_SENTRY_DSN: process.env.SENTRY_DSN,
        NEXT_PUBLIC_SENTRY_ENVIRONMENT: process.env.SENTRY_ENVIRONMENT,
        NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE: process.env.SENTRY_TRACES_SAMPLE_RATE,
        NEXT_PUBLIC_TAONGA_PORTAL_URL: process.env.NEXT_PUBLIC_TAONGA_PORTAL_URL,
        NEXT_PUBLIC_ZENDESK_URL: process.env.NEXT_PUBLIC_ZENDESK_URL,
    },
    {
        schema: (z) => ({
            NEXT_PUBLIC_AUTO_TRANSLATION_ENABLE: z.stringbool().default(false),
            NEXT_PUBLIC_LANG: z.enum(['en', 'ru']).default('en'),
            NEXT_PUBLIC_NAVBAR_ABOUT_PAGE_LINK_ENABLE: z.stringbool().default(false),
            NEXT_PUBLIC_SENTRY_DSN: z.url(),
            NEXT_PUBLIC_SENTRY_ENVIRONMENT: z.string().min(1),
            NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE: z.coerce.number().min(0).max(1).default(1.0),
            NEXT_PUBLIC_TAONGA_PORTAL_URL: z.url(),
            NEXT_PUBLIC_ZENDESK_URL: z.url(),
        }),
    }
)
